// extracted by mini-css-extract-plugin
module.exports = {"app":"style_app__3SIWm","initError":"style_initError__PKItk","errorText":"style_errorText__1e8HD","error":"style_error__361Rh","contact":"style_contact__18rMI"};